import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=1988fe4e&scoped=true&"
import script from "./TermList.vue?vue&type=script&lang=js&"
export * from "./TermList.vue?vue&type=script&lang=js&"
import style0 from "./TermList.vue?vue&type=style&index=0&id=1988fe4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988fe4e",
  null
  
)

export default component.exports